/*
 * @Author: fengyanjing
 * @Date: 2020-06-02 14:05:28
 * @Description:实力瘦战略合伙人首页
 * @FilePath: /frontend/src/pages/rebate/shilishou/strategy/rebate-home/index.js
 */
import CompRebateLayoutOne from "@/components/rebate/comp-rebate-layout-one/index.vue";
import rebateMixin from "@/mixins/shilishou-rebate";
import { getStrategyRebateSum } from "@/service/rebate/shilishouRebate";

export default {
  name: "strategy-rebate-home",
  mixins: [rebateMixin],
  components: {
    CompRebateLayoutOne,
  },
  data() {
    return {
      isRebateHome: true
    };
  },
  methods: {
    //  初始化页面
    init() {
      const { startTime, endTime, agentId } = this;
      getStrategyRebateSum({
        startTime,
        endTime,
        userId: agentId,
      }).then((data) => {
        this.rebateInfo = data;
      });
    },
  },
};
